var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLips2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 34,
    viewBox: "0 0 71 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-lips2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 34
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lips2",
    clipPath: "url(#clip-lips2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "l\\xE4pp",
    transform: "translate(-342.247 -301.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M6.364,3.916s7.805.49,14.276,1.509,2.852,2.566,11.607,2.566c7.526,0,6.972-1.548,13.758-2.566S59.391,3.916,59.391,3.916s-2.638,1.978-7.708,6.514c-4.618,4.134-10.9,9.447-19.435,9.447-9.113,0-15.007-4.615-19.435-9.447C9.329,6.633,6.364,3.916,6.364,3.916Z",
    transform: "translate(345.673 308.63)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M7.063,3.2a60.107,60.107,0,0,0,6.41,6.363c4.01,3.513,10.019,8.873,18.759,8.873,7.514,0,13.621-5.557,18.575-8.873A74.36,74.36,0,0,0,57.881,4.5a82.318,82.318,0,0,1-6.246,5.93c-4.61,4.134-10.884,9.447-19.4,9.447-9.1,0-14.982-4.615-19.4-9.447A67.543,67.543,0,0,1,7.063,3.2Z",
    transform: "translate(345.673 309.298)",
    fill: "#7D7B8B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M4.489,5.33S7.89,7.4,13.563,6.669s11.023-2.449,12.88-2.33,4.082,2.914,8.267,2.914,7.034-3.2,8.475-2.914,6.847,1.507,12.289,2.33a64.279,64.279,0,0,0,10.245.584,18.6,18.6,0,0,1-8.985,2.817c-4.986.113-5.917.638-11.341,1.587S38.764,13.7,34.71,13.641s-7.067-2.055-13.587-3-7.817-.673-12.16-1.519S4.489,5.33,4.489,5.33Z",
    transform: "translate(343.31 304.179)",
    fill: "#7D7B8B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLips2);
export default __webpack_public_path__ + "static/media/lips2.a4c7cccbffbc6232b3be881e817dbbd9.svg";
export { ForwardRef as ReactComponent };